import React from "react"
import { Link, graphql } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"

//import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const intl = useIntl()
  const post = data.markdownRemark
  const siteTitle = data.site.siteMetadata.shortTitle
  const { previous, next } = pageContext

  return (
    <Layout location={location} title={siteTitle}>
      <SEO
        location={location}
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        lang={data.site.siteMetadata.locale}
        canonical={post.frontmatter.canonical}
      />
      <article className="prose lg:prose-xl dark:prose-dark max-w-none">
        <header>
          <h1 style={{ marginBottom: 0 }}>
            {post.frontmatter.title}
          </h1>
          <p className="opacity-70 uppercase">
            {intl.formatDate(post.frontmatter.date, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </p>
        </header>
        {post.frontmatter.description ? (
          <section className="text-center font-serif opacity-90" dangerouslySetInnerHTML={{ __html: post.frontmatter.description }} />
        ) : undefined}
        {post.frontmatter.showTableOfContents ? (
          <section
            className="mb-10"
            dangerouslySetInnerHTML={{
              __html: `<h2>${intl.formatMessage({ id: 'tableOfContents' })}</h2>` + post.tableOfContents
            }}
          />
        ) : undefined}
        <section dangerouslySetInnerHTML={{ __html: post.html }} />
        {/*
        <hr />
        <footer>
          <Bio />
        </footer>
        */}
      </article>

      <nav>
        <ul
          className="flex flex-wrap justify-between mt-8"
        >
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev" className="font-semibold hover:underline">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next" className="font-semibold hover:underline">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        shortTitle
        locale
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      tableOfContents(
        heading: null
        maxDepth: 2
      )
      frontmatter {
        title
        date
        description
        canonical
        showTableOfContents
      }
    }
  }
`
